import { useEffect } from "react";
import Router from "./router";
import { getCookie, getLatLong, setCookie } from "./utils";
import { v4 as uuidv4 } from "uuid";
import { onMessage } from "firebase/messaging";
import { messaging } from "./firebase";

function App({ serverProps }: any) {
  const doGetLatLong = async () => {
    const data = await getLatLong();
    if (data?.latitude && data?.longitude) {
      setCookie(
        "coordinates",
        {
          latitude: data?.latitude,
          longitude: data?.longitude,
        },
        1
      );
    }
  };

  useEffect(() => {
    if (!getCookie("coordinates")) doGetLatLong();
    if (!getCookie("userUuid")) {
      const userUuid = uuidv4();
      setCookie("userUuid", userUuid);
    }
    // Listen for foreground messages
    if (messaging) {
      onMessage(messaging, (payload: any) => {
        // Handle foreground notification display
        const notificationTitle = payload.notification.title;
        const notificationOptions = {
          body: payload?.notification?.body || "",
          icon: "https://savitarrealty.in/favicon-96x96.png", // Icon for the notification
          image: payload?.notification?.image || "", // Large image in the notification
          tag: payload?.notification?.tag || new Date().getTime().toString(), // Ensure unique tag
        };
        const notification = new Notification(
          notificationTitle,
          notificationOptions
        );

        // Add click event listener for notification
        notification.onclick = () => {
          // Example: Redirect to a specific URL based on notification data
          window.focus(); // Ensure the app window is focused
          const redirectUrl = payload?.data?.redirectUrl || "/"; // Default to home if URL is not provided
          window.location.href = redirectUrl; // Redirect the user
        };
      });
    }
  }, []);

  return <Router serverProps={serverProps} />;
}

export default App;
